import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SearchIcon, ChevronDownIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { useContent } from '../ContentContext';
export function Hero() {
  const navigate = useNavigate();
  const {
    content
  } = useContent();
  const hero = content.hero;
  const [category, setCategory] = useState('');
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');
  const [address, setAddress] = useState('');
  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    navigate(category ? `/utbud?kategori=${encodeURIComponent(category)}` : '/utbud');
  };
  return <section className="relative flex min-h-[90vh] w-full flex-col items-center justify-center pt-24 pb-12" data-id="element-256" data-mp="ncgkuhjyctus">
      {/* Premium Background */}
      <div className="absolute inset-0 -z-10 bg-[#f8f9fa]" data-id="element-257" data-mp="3d2bj5ngruvuh">
        <div className="absolute inset-0 bg-cover bg-center opacity-10 mix-blend-multiply" style={{
        backgroundImage: `url(${hero.backgroundImage})`
      }} data-id="element-258" data-mp="382p91mw8pvpw" />
        <div className="absolute inset-0 bg-gradient-to-b from-white/80 via-white/40 to-[#f8f9fa]" data-id="element-259" data-mp="3o7ls3r2jl6oy" />
      </div>

      <div className="relative z-10 w-full max-w-5xl px-6 text-center" data-id="element-260" data-mp="39al9cd2bwm2m">
        <Reveal data-id="element-261" data-mp="39cfotbutzlzb">
          {hero.logo && <img src={hero.logo} alt="Smaken som Baken" className="mx-auto h-28 w-auto object-contain mix-blend-multiply sm:h-36 md:h-44" data-id="element-262" data-mp="3e8mssz3o2nem" />}
          <span className="mt-2 inline-block rounded-full bg-black/5 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-gray-900 backdrop-blur-sm" data-id="element-263" data-mp="359t0hkxdcj6v">
            {hero.badge}
          </span>
          <h1 className="mt-6 whitespace-pre-line font-display text-5xl font-medium tracking-tight text-gray-900 sm:text-6xl md:text-7xl lg:text-[5rem] leading-[1.1]" data-id="element-264" data-mp="2vjzowjx8842m">
            {hero.title}
          </h1>
          <p className="mx-auto mt-6 max-w-2xl text-lg text-gray-600 md:text-xl" data-id="element-265" data-mp="2ljgzzaqt1xdu">
            {hero.subtitle}
          </p>
        </Reveal>

        <Reveal delay={0.1} data-id="element-266" data-mp="s3umzlkswo5c">
          {/* Airbnb-style Floating Search Bar */}
          <form onSubmit={handleSearch} className="mx-auto mt-12 flex w-full max-w-4xl flex-col items-center rounded-3xl bg-white p-2 shadow-floating ring-1 ring-black/5 md:flex-row md:rounded-full" data-id="element-267" data-mp="n98crlqgh1mu">
            
            <div className="group relative flex w-full flex-1 cursor-pointer flex-col rounded-full px-6 py-3 transition-colors hover:bg-gray-50 md:w-auto" data-id="element-268" data-mp="dbaqv4w2jgxe">
              <label className="text-[10px] font-bold uppercase tracking-wider text-gray-500" data-id="element-269" data-mp="16346ov87u0e2">Kategori</label>
              <select className="w-full cursor-pointer appearance-none bg-transparent text-base font-medium text-gray-900 outline-none" value={category} onChange={e => setCategory(e.target.value)} data-id="element-270" data-mp="11152xk8kd1gl">
                <option value="" disabled hidden data-id="element-271" data-mp="3hr3tc077qj7x">Vad söker du?</option>
                {hero.searchCategories.map(c => <option key={c} data-id="element-272" data-mp="1xam4qoj23mxv">{c}</option>)}
              </select>
              <ChevronDownIcon className="absolute right-6 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none" data-id="element-273" data-mp="21by0lbsix4ei" />
            </div>
            
            <div className="hidden h-10 w-px bg-gray-200 md:block" data-id="element-274" data-mp="2b0plx132wqgg" />
            
            <div className="group flex w-full flex-1 cursor-pointer rounded-full transition-colors hover:bg-gray-50 md:w-auto" data-id="element-275" data-mp="2b2so0jhiaa1j">
              <div className="flex flex-1 flex-col px-6 py-3" data-id="element-276" data-mp="2kynaxqsrira4">
                <label className="text-[10px] font-bold uppercase tracking-wider text-gray-500" data-id="element-277" data-mp="2l101gscl69ys">Datum</label>
                <input type="date" className="w-full cursor-pointer bg-transparent text-base font-medium text-gray-900 outline-none" value={date} onChange={e => setDate(e.target.value)} data-id="element-278" data-mp="2oynzi49ksiuw" />
              </div>
              <div className="hidden h-10 w-px self-center bg-gray-200 md:block" data-id="element-279" data-mp="zndrthx4fm7h" />
              <div className="flex w-24 flex-col px-4 py-3" data-id="element-280" data-mp="49jdg5ykopmn">
                <label className="text-[10px] font-bold uppercase tracking-wider text-gray-500" data-id="element-281" data-mp="3vigsajh2h24n">Tid</label>
                <input type="time" className="w-full cursor-pointer bg-transparent text-base font-medium text-gray-900 outline-none" value={time} onChange={e => setTime(e.target.value)} data-id="element-282" data-mp="e8innsyzktbr" />
              </div>
            </div>

            <div className="hidden h-10 w-px bg-gray-200 md:block" data-id="element-283" data-mp="3csqxhwdb0gcq" />

            <div className="group flex w-full flex-1 cursor-pointer flex-col rounded-full px-6 py-3 transition-colors hover:bg-gray-50 md:w-auto" data-id="element-284" data-mp="3rgbwpf725vfd">
              <label className="text-[10px] font-bold uppercase tracking-wider text-gray-500" data-id="element-285" data-mp="3mnah14z11ruq">Leverans till</label>
              <input type="text" placeholder="Företagsadress..." className="w-full bg-transparent text-base font-medium text-gray-900 outline-none placeholder:text-gray-400" value={address} onChange={e => setAddress(e.target.value)} data-id="element-286" data-mp="2u0pow2aq9bq4" />
            </div>

            <button type="submit" className="mt-2 flex h-14 w-full items-center justify-center gap-2 rounded-full bg-black px-8 text-base font-medium text-white transition-transform hover:scale-[1.02] md:mt-0 md:w-auto md:shrink-0" data-id="element-287" data-mp="zlslnn4qcyng">
              <SearchIcon className="h-5 w-5" data-id="element-288" data-mp="1s72d4yuvsn56" />
              <span data-id="element-289" data-mp="1x8hx0nlbonlz">Sök</span>
            </button>
          </form>
        </Reveal>

        <Reveal delay={0.2} data-id="element-290" data-mp="1j902drlcig4p">
          <div className="mt-10 flex flex-wrap justify-center gap-2" data-id="element-291" data-mp="1j7oxtpk2t4cj">
            {hero.quickLinks.map(cat => <button key={cat} type="button" onClick={() => navigate(cat === 'Visa allt' ? '/utbud' : `/utbud?kategori=${encodeURIComponent(cat)}`)} className="rounded-full border border-gray-200 bg-white px-5 py-2 text-sm font-medium text-gray-700 shadow-sm transition-all hover:border-gray-300 hover:shadow-md" data-id="element-292" data-mp="1n88uyt4ng7yo">
                {cat}
              </button>)}
          </div>
        </Reveal>
      </div>
    </section>;
}